import { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { Box, Typography, CircularProgress, Card } from "@mui/material";

// ⭐ Reusable ViewDetailsBtn
import ViewDetailsBtn from "../ViewDetailsBtn/ViewDetailsBtn";
import analyticsService from "../../../../services/analyticsService";
import config from "../../../../config";
import { getDateRangeFromFilter } from "../../../../utils/dateFilterUtils";

const MostRecommendedCategories = ({ dateFilterValue }) => {
  const [categoriesData, setCategoriesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const dateRange = getDateRangeFromFilter(dateFilterValue);
        const response = await analyticsService.getMostRecommendedCategories(
          config.clientId,
          5,
          dateRange.start_date,
          dateRange.end_date
        );

        if (response.success && response.data) {
          setCategoriesData(response.data);
        } else {
          setError(response.message || "Failed to fetch data");
        }
      } catch (err) {
        console.error("Error fetching most recommended categories:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (config.clientId) {
      fetchData();
    }
  }, [dateFilterValue]);

  const chartState = {
    series: [{ data: categoriesData.map((d) => d.recommended_count) }],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: { show: false },
        fontFamily: "Inter, sans-serif",
      },
      plotOptions: {
        bar: {
          borderRadius: 6,
          horizontal: true,
          endingShape: "rounded",
        },
      },
      dataLabels: { enabled: false },
      colors: ["#6f42c1"],
      xaxis: {
        categories: categoriesData.map((d) => d.product_type),
        labels: { style: { colors: "#495057", fontSize: "14px" } },
      },
      yaxis: {
        labels: { style: { colors: "#495057", fontSize: "14px" } },
      },
      tooltip: { theme: "dark" },
      grid: {
        show: true,
        borderColor: "#e9ecef",
        row: { colors: ["transparent"], opacity: 0.5 },
      },
    },
  };

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 3,
        paddingTop: "10px",
        paddingLeft: "0px",
        paddingRight: "0px",
        paddingBottom: "0px",
      }}
    >
      {/* Header */}
      <Box display="flex" alignItems="center" px={2} mb={"4px"}>
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{
            color: "#6D5DD2",
            flexGrow: 1,
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}
        >
          Most Recommended Categories
        </Typography>


        <ViewDetailsBtn
          redirectTo="/analytics/most-recommended/details"
          align="right"
          dateFilterValue={dateFilterValue}
        />
      </Box>

      {/* Chart */}
      <Box px={2}>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height={350}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box display="flex" justifyContent="center" alignItems="center" height={350}>
            <Typography color="error">{error}</Typography>
          </Box>
        ) : categoriesData.length > 0 ? (
          <ReactApexChart
            options={chartState.options}
            series={chartState.series}
            type="bar"
            height={350}
          />
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" height={350}>
            <Typography>No data available</Typography>
          </Box>
        )}
      </Box>
    </Card>
  );
};

export default MostRecommendedCategories;


// // MostRecommendedCategories.js
// import React from "react";
// import { useState } from "react";
// import ReactApexChart from "react-apexcharts";

// const MostRecommendedCategories = () => {
//   const [state, setState] = React.useState({
//     series: [
//       {
//         data: [400, 380, 348, 270, 240],
//       },
//     ],
//     options: {
//       chart: {
//         type: "bar",
//         height: 350,
//       },
//       plotOptions: {
//         bar: {
//           borderRadius: 4,
//           borderRadiusApplication: "end",
//           horizontal: true,
//         },
//       },
//       dataLabels: {
//         enabled: false,
//       },
//       xaxis: {
//         categories: [
//           // "South Korea",
//           // "Canada",
//           // "United Kingdom",
//           // "Netherlands",
//           // "Italy",
//           "Edibles",
//           "Flower",
//           "Vapes",
//           "Topicals",
//           "Tinctures",
//         ],
//       },
//     },
//   });

//   return (
//     <div>
//       <div id="chart">
//         <h3>Most Recommended Categories</h3>
//         <ReactApexChart
//           options={state.options}
//           series={state.series}
//           type="bar"
//           height={350}
//         />
//       </div>
//     </div>
//   );
// };

// export default MostRecommendedCategories;


/////////////////////////////////////////////////////////////////////////////////////////////////

// import React from "react";
// import { useNavigate } from "react-router-dom";
// import ReactApexChart from "react-apexcharts";
// import { Box, Button, Typography } from "@mui/material";

// const MostRecommendedCategories = () => {
//   const navigate = useNavigate();

//   const chartState = {
//     series: [{ data: [400, 380, 348, 270, 240] }],
//     options: {
//       chart: { type: "bar", height: 350 },
//       plotOptions: { bar: { borderRadius: 4, borderRadiusApplication: "end", horizontal: true } },
//       dataLabels: { enabled: false },
//       xaxis: { categories: ["Edibles", "Flower", "Vapes", "Topicals", "Tinctures"] },
//     },
//   };

//   return (
//     <Box p={3}>
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <Typography variant="h6" fontWeight="600">Most Recommended Categories</Typography>
//         <Button
//           variant="contained"
//           size="small"
//           onClick={() => navigate("/analytics/most-recommended/details")}
//           sx={{ borderRadius: "8px", textTransform: "none" }}
//         >
//           View Details →
//         </Button>
//       </Box>

//       <ReactApexChart options={chartState.options} series={chartState.series} type="bar" height={350} />
//     </Box>
//   );
// };

// export default MostRecommendedCategories;




// import React from "react";
// import { useNavigate } from "react-router-dom";
// import ReactApexChart from "react-apexcharts";
// import { Box, Button, Typography } from "@mui/material";

// const MostRecommendedCategories = () => {
//   const navigate = useNavigate();

//   const chartState = {
//     series: [{ data: [400, 380, 348, 270, 240] }],
//     options: {
//       chart: {
//         type: "bar",
//         height: 350,
//         toolbar: { show: false },
//         fontFamily: 'Inter, sans-serif',
//       },
//       plotOptions: {
//         bar: {
//           borderRadius: 6,
//           horizontal: true,
//           endingShape: "rounded",
//         },
//       },
//       dataLabels: { enabled: false },
//       colors: ["#6f42c1"], // Trezo purple
//       xaxis: {
//         categories: ["Edibles", "Flower", "Vapes", "Topicals", "Tinctures"],
//         labels: { style: { colors: "#495057", fontSize: '14px' } },
//       },
//       yaxis: {
//         labels: { style: { colors: "#495057", fontSize: '14px' } },
//       },
//       tooltip: { theme: 'dark' },
//       grid: {
//         show: true,
//         borderColor: "#e9ecef",
//         row: { colors: ["transparent"], opacity: 0.5 },
//       },
//     },
//   };

//   return (
//     <Box p={3}>
//       {/* Header with title and button */}
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <Typography variant="h6" fontWeight="600">
//           Most Recommended Categories
//         </Typography>

//         <Button
//           variant="contained"
//           size="small"
//           onClick={() => navigate("/analytics/most-recommended/details")}
//           sx={{ borderRadius: "8px", textTransform: "none" }}
//         >
//           View Details →
//         </Button>
//       </Box>

//       {/* Chart */}
//       <ReactApexChart
//         options={chartState.options}
//         series={chartState.series}
//         type="bar"
//         height={350}
//       />
//     </Box>
//   );
// };

// export default MostRecommendedCategories;
